export const profile = {
    text1: "Informações da minha conta",
    text2: "Informações pessoais",
    text3: "Nome",
    text4: "Número do documento",
    text5: "Telefone",
    text6: "País",
    text7: "Endereço de e-mail",
    text8: "Atualizar informações",
    text9: "Dados de acesso",
    text10: "Senha",
    text11: "Confirmar senha",
    text12: "Atualizar senha",

    // Corrections
    p1: "Configurações da conta",
    p2: "Dados do perfil",
    p3: "Login e segurança",
    p4: "Informações de faturamento",
    p5: "Endereço de e-mail principal",
    p6: "É aqui que você receberá todas as comunicações da WACheckin",
    p7: "Informações da conta",
    p8: "Gerencie os dados da sua conta.",
    p9: "Nome",
    p10: "Digite o nome completo",
    p11: "Número do documento",
    p12: "Digite o número do documento",
    p13: "Telefone",
    p14: "Digite o número de telefone",
    p15: "Login e segurança",
    p16: "Atualize sua senha e proteja sua conta.",
    p17: "Senha da conta",
    p18: "Última atualização:",
    p19: "Alterar senha",
    p20: "Informações de faturamento",
    p21: "Gerencie os dados da sua conta.",
    p22: "Nome da empresa",
    p23: "Digite o nome da empresa",
    p24: "CPF/CNPJ",
    p25: "Digite o CPF/CNPJ",
    p26: "Endereço de faturamento",
    p27: "Digite o endereço de faturamento",
    p28: "País",
    p29: "Estado",
    p30:'CEP',
    p31:`Nenhum dado de faturamento`,
    p32:`As informações de faturamento são carregadas automaticamente quando você assina um plano.`,
};